import React from "react";
import Home from "./dashboard/components/Home/Home";

const ArchitectDashboard = () => {
  return <Home />;
};

export default ArchitectDashboard;
